import { render, staticRenderFns } from "./GeofenceManager.vue?vue&type=template&id=0affadf6&scoped=true&"
import script from "./GeofenceManager.vue?vue&type=script&lang=js&"
export * from "./GeofenceManager.vue?vue&type=script&lang=js&"
import style0 from "./GeofenceManager.vue?vue&type=style&index=0&id=0affadf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0affadf6",
  null
  
)

export default component.exports